interface HintBlockProps {
  show: boolean;
  children: React.ReactNode;
  testId?: string;
}

export function HintBlock({ show, children, testId }: HintBlockProps) {
  if (!show || !children) return null;
  return (
    <div
      className="mb-4 p-2 rounded bg-primary/10 border border-primary/20 text-xs text-primary"
      data-testid={testId}
    >
      {children}
    </div>
  );
}
